import { useAssetActionModalStore } from '@/store/asset-action-modal.store';
import { ListViewItem } from '@ingka/list-view';
import { translate } from '@repo/phrase';
import type { AssetType } from '@repo/types/asset';

import { MODAL } from '@/components/modals/asset-modal.types';

import { useAssetParams } from '@/hooks/asset.hooks';

import type { AssetActionProps } from '../../asset-context-buttons.types';

const getDeleteAssetTitle = (assetType: AssetType) => {
    if (assetType === 'draft') {
        return translate('order_status_header_delete');
    }
    if (assetType === 'quote') {
        return translate('order_status_header_quotation_delete');
    }
    return '';
};

const AssetDeleteListItem = ({ onClose, context }: AssetActionProps) => {
    const { assetType } = useAssetParams();
    const setActiveModal = useAssetActionModalStore((state) => state.setActiveModal);
    return (
        <ListViewItem
            title={getDeleteAssetTitle(assetType)}
            control="navigational"
            controlIcon={context === 'modal' ? 'chevronRight' : null}
            inset={context === 'dropdown'}
            emphasised={context === 'modal'}
            onClick={() => {
                setActiveModal(MODAL.DELETE);
                onClose?.();
            }}
        />
    );
};

export const AssetDeleteAction = ({ type, ...props }: AssetActionProps) => {
    if (type === 'button') {
        return null;
    }
    return <AssetDeleteListItem key="delete-list-item" {...props} />;
};
